import React from 'react';
import logoIcon from '../assets/logo-icon-exact.png';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

function Terms() {
  const navigate = useNavigate();

  return (
    <div className="settings-page">
      <header>
        <div className="logo" onClick={() => navigate('/')}>
          <div className="logo-icon"><img src={logoIcon} alt="" /></div>
          <div className="logo-text">TradeReady<span>Pro</span></div>
        </div>
        <div className="header-right">
          <Link to="/quiz" className="dark-toggle">Home</Link>
          <Link to="/settings" className="dark-toggle" title="Settings">⚙️</Link>
        </div>
      </header>

      <div className="settings-wrap" style={{ maxWidth: 720 }}>
        <button className="settings-back" onClick={() => navigate(-1)}>← Back</button>
        <h1 className="settings-title">Terms of Service</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '2rem' }}>Last updated: June 2026</p>

        <div className="static-content">

          <h2>Using TradeReady Pro</h2>
          <p>By creating an account or using TradeReady Pro, you agree to these terms. You must be 18 or older to subscribe. If you are using the platform on behalf of an employer or organization, you confirm that you have the authority to accept these terms on their behalf.</p>

          <h2>What you get</h2>
          <p>A subscription gives you access to all practice questions, quiz modes, and progress tracking features available on TradeReady Pro at the time of your subscription. We may add new content and features over time — these are included at no extra cost.</p>

          <h2>What we don't guarantee</h2>
          <p>TradeReady Pro is a study tool. We make no guarantee that using the platform will result in passing your trade certification exam. The questions are designed to help you prepare based on the relevant codes and regulations, but exam boards may change their content, format, or passing requirements at any time. Your results depend on your effort, preparation, and the exam itself.</p>

          <h2>Subscriptions and billing</h2>
          <ul>
            <li>Subscriptions are billed monthly or annually and renew automatically through Stripe</li>
            <li>You can cancel at any time from <Link to="/settings">Settings → Manage Subscription</Link></li>
            <li>Cancellation stops future charges — your access continues until the end of the current billing period</li>
            <li>We do not offer refunds for partial billing periods, but if something went wrong, contact us at <a href="mailto:support@tradereadypro.ca">support@tradereadypro.ca</a> and we will work with you</li>
          </ul>

          <h2>Your account</h2>
          <p>You are responsible for keeping your login credentials secure. Subscriptions are for individual use — please do not share your account. We reserve the right to suspend accounts that appear to be shared or otherwise misused.</p>

          <h2>Our content</h2>
          <p>All practice questions, answer explanations, and code references on TradeReady Pro are original works independently created by the TradeReady Pro team. No question content has been copied or reproduced from any third-party publication, exam provider, or code book. All content is protected under Canadian copyright law.</p>
          <p>You may not copy, reproduce, scrape, or redistribute any content from this platform without our written permission. You are welcome to use the platform to study — that is what it is for.</p>

          <h2>Your quiz data</h2>
          <p>Your quiz scores and progress belong to you. You can delete all of it at any time by deleting your account from the <Link to="/settings">Settings page</Link>.</p>

          <h2>Limitation of liability</h2>
          <p>TradeReady Pro is provided as-is. We are not liable for any loss or outcome resulting from your use of the platform, including exam failures, missed certifications, or employment decisions. Our total liability to you for any claim is limited to the amount you paid for your subscription in the 30 days preceding the claim.</p>

          <h2>Changes to these terms</h2>
          <p>We may update these terms from time to time. If we make significant changes, we will let you know by email. Continued use of the app after changes are posted means you accept the updated terms.</p>

          <h2>Governing law</h2>
          <p>These terms are governed by the laws of the Province of Ontario, Canada. Any disputes will be resolved in the courts of Ontario.</p>

          <h2>Contact</h2>
          <p><a href="mailto:support@tradereadypro.ca">support@tradereadypro.ca</a></p>

        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
